<template>
  <span>
    <a-button style="height: 40px;width: 150px;" type="primary" @click="nextStep" v-if="!isshow" :loading="loading">确认提交</a-button>
    <a-button style="height: 40px;width: 150px;" type="primary" @click="submitMaterial" v-if="isshow" :loading="loading">确认提交</a-button>
    <div v-if="showOverlay" class="modal-overlay">
      <div class="custom-modal">
        <img src="../checkInfo.png" alt="" class="custom-modal-image">
        <div class="custom-modal-word">系统正在自动为您审核申报事项信息准确性，预计等待时间10-15s，请稍后...</div>
      </div>
    </div>
    <div>
      <a-modal
        v-model="visible"
        title="智能预审"
        width="859px"
        height="826px"
        :mask-closable="false"
        @cancel="handleCancel">
        <template slot="footer">
          <div class="modal-footer">
            <span class="modal-footer-title">智能预检发现您有信息校验未通过，请修改后再提交</span>
            <span class="modal-footer-button">
              <a-button key="back" :loading="modalLoading" @click="handleCancel">
                取消办理
              </a-button>
              <a-button style="margin-left: 16px" key="submit" type="primary" :loading="modalLoading" @click="handleEdit">
                返回修改
              </a-button>
            </span>
          </div>
        </template>
        <a-row>
          <a-col :span="12">
            <img src="../checkInfo.png" alt="" class="modal-image">
          </a-col>
          <a-col :span="12" style="overflow-x: hidden;overflow-y: auto;height: 450px">
            <div class="list-title" v-if="checkFieldRule && checkFieldRule.length > 0">
              <img src="../point.svg" alt="" class="list-image">
              <span>填报信息预检:</span>
            </div>
            <div style="margin-bottom: 20px" v-if="checkFieldRule && checkFieldRule.length > 0">
              <div v-for="item in checkFieldRule" :key="item.ruleTitle">
                <div class="list-sub-title">
                  <span v-if="item.ruleTitle && item.ruleTitle.length > 16">
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>{{ item.ruleTitle }}</span>
                      </template>
                      {{ item.ruleTitle | titleFilter }}
                    </a-tooltip>
                  </span>
                  <span v-else>
                    <span>{{ item.ruleTitle }}</span>
                  </span>
                  <span v-if="item.resultStatus">
                    <a-tag class="list-sub-tagOk">预检通过</a-tag>
                  </span>
                  <span v-else>
                    <a-tag class="list-sub-tagOff">未通过</a-tag>
                  </span>
                </div>
                <div v-if="!item.resultStatus && item.resultInfoList && item.resultInfoList.length > 0" v-for="subItem in item.resultInfoList" :key="subItem">
                  <div class="list-sub-message">· {{ subItem }}</div>
                </div>
              </div>
            </div>
            <div class="list-title" v-if="checkMaterialRule && checkMaterialRule.length > 0">
              <img src="../point.svg" alt="" class="list-image">
              <span>材料信息预检:</span>
            </div>
            <div style="margin-bottom: 20px" v-if="checkMaterialRule && checkMaterialRule.length > 0">
              <div v-for="item in checkMaterialRule" :key="item.ruleTitle">
                <div class="list-sub-title">
                  <span v-if="item.ruleTitle && item.ruleTitle.length > 16">
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>{{ item.ruleTitle }}</span>
                      </template>
                      {{ item.ruleTitle | titleFilter }}
                    </a-tooltip>
                  </span>
                  <span v-else>
                    <span>{{ item.ruleTitle }}</span>
                  </span>
                  <span v-if="item.resultStatus">
                    <a-tag class="list-sub-tagOk">预检通过</a-tag>
                  </span>
                  <span v-else>
                    <a-tag class="list-sub-tagOff">未通过</a-tag>
                  </span>
                </div>
                <div v-if="!item.resultStatus && item.resultInfoList && item.resultInfoList.length > 0" v-for="subItem in item.resultInfoList" :key="subItem">
                  <div class="list-sub-message">· {{ subItem }}</div>
                </div>
              </div>
            </div>
            <div class="list-title" v-if="consistencyRule && consistencyRule.length > 0">
              <img src="../point.svg" alt="" class="list-image">
              <span>材料一致性预检:</span>
            </div>
            <div style="margin-bottom: 20px" v-if="consistencyRule && consistencyRule.length > 0">
              <div v-for="item in consistencyRule" :key="item.ruleTitle">
                <div class="list-sub-title">
                  <span v-if="item.ruleTitle && item.ruleTitle.length > 16">
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>{{ item.ruleTitle }}</span>
                      </template>
                      {{ item.ruleTitle | titleFilter }}
                    </a-tooltip>
                  </span>
                  <span v-else>
                    <span>{{ item.ruleTitle }}</span>
                  </span>
                  <span v-if="item.resultStatus">
                    <a-tag class="list-sub-tagOk">预检通过</a-tag>
                  </span>
                  <span v-else>
                    <a-tag class="list-sub-tagOff">未通过</a-tag>
                  </span>
                </div>
                <div v-if="!item.resultStatus && item.resultInfoList && item.resultInfoList.length > 0" v-for="subItem in item.resultInfoList" :key="subItem">
                  <div class="list-sub-message">· {{ subItem }}</div>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </a-modal>
    </div>
  </span>
</template>
<script>

import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import { jiopAPI } from '@/api/jiopweb/jiop'
import { sm2 } from 'sm-crypto'

export default {
  name: 'SubmitButton',
  components: {
  },
  props: {
    isshow: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      intelligentApproval: this.$route.query.intelligentApproval,
      wholeIntelligentApproval: this.$route.query.wholeIntelligentApproval,
      itemId: this.$route.query.itemId,
      stepNo: parseInt(this.$route.query.stepNo),
      total: parseInt(this.$route.query.total),
      iid: this.$route.query.iid, // 补正的办件id
      applyNo: this.$route.query.applyNumber, // 补正办件编号
      applyId: this.$route.query.applyId,
      loading: false,
      showOverlay: false,
      visible: false,
      modalLoading: false,
      approveResult: false,
      approveMsgInfo: null,
      consistencyRule: [], // 一致性
      checkMaterialRule: [], // 材料
      checkFieldRule: [], // 字段
      remainingTime: 30, // 剩余时间，单位：秒
      timer: null, // 计时器
      intervalId: null, // 计时器
      receiveParams: {}
    }
  },
  filters: {
    titleFilter (val) {
      if (val.length > 16) {
        return val.substr(0, 16) + '...'
      } else {
        return val
      }
    }
  },
  beforeDestroy () {
    // 组件销毁前清除计时器，以防止内存泄漏
    clearInterval(this.timer)
    clearInterval(this.intervalId)
  },
  methods: {
    submitMaterial () {
      this.loading = true
      // 是否开启智审 先不管补正流程
      // if (this.intelligentApproval === 'on') {
      //   this.showOverlay = true
      //   this.remainingTime = 1
      //   // 此时异步调用方法 return一个值 this.checkInfo 如果有值则弹窗 无值则弹出提示是否提交
      //   this.startTimer(1)
      // } else {
      // 材料
      if (sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) {
        const uploadInfo = JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) || []
        uploadInfo.forEach(item => {
          if (item.data && item.data.length > 0) {
            item.data.forEach(ele => {
              ele.base64 = ''
              ele.thumbUrl = ''
            })
          }
        })
        // 材料
        console.log('提交数据', uploadInfo)
        const uploadMaterial = JSON.stringify(uploadInfo)
        const pubilcKey = '0447c33b1ff9cbb2f15aae1b753c8a306e605a6b87b9441402f5e757dcbcfe4ab28bc340f8e6508918ca59799940d8b5f9fd556211f5803d2ae4aec580de48268d'
        const infoStr = this.encrypt(uploadMaterial, pubilcKey)
        jiopAPI.submitReplay({ handlingId: this.iid, applyNumber: this.applyNo, applyId: this.applyId, uploadMaterial: infoStr }).then(res => {
          if (res.success) {
            this.loading = false
            this.cleanSession()
            // const url = this.$router.resolve({ path: '/replenishMatterSuccess', query: { itemId: this.itemId, applyId: res.data.transactNo, stepNo: this.stepNo++, total: this.total } })
            // window.open(url.href, '_blank')
            this.$router.push({ path: '/replenishMatterSuccess', query: { itemId: this.itemId, applyId: res.data.transactNo, stepNo: this.stepNo++, total: this.total } })
          } else {
            this.loading = false
          }
        })
      }
    },
    nextStep () {
      this.loading = true
      if (this.total === this.stepNo + 1) {
        this.getinfoStr()
      } else {
        this.$message.error('步骤未走完，无法提交')
      }
    },
    // 清除session
    cleanSession () {
      sessionStorage.removeItem(this.itemId + '_listOfSituations')
      sessionStorage.removeItem(this.itemId + '_model')
      sessionStorage.removeItem(this.itemId + '_infoStr')
      sessionStorage.removeItem(this.itemId + '_JiopwebReceive')
      sessionStorage.removeItem(this.itemId + '_JiopwebMaterial')
    },
    saveDraft (type) {
      const that = this
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
          const usreId = userParams.uid ? userParams.uid : ''
          // jiopWebAPI.getPublicKey({ userId: usreId }).then(res => {
          jiopWebAPI.getPublicKey({ userType: 1, appType: 1 }).then(res => {
            if (res.success) {
              that.publicKey = res.data.publicKey
              const encryptString = this.submitDataHandle()
              jiopWebAPI.materialSubmit({ infoStr: encryptString, applyUserId: usreId }).then(res => {
                if (res.success) {
                  if (type === 1) {
                    // type 1  取消办理  弹框需要消失
                    that.visible = false
                  }
                  that.$message.success('已经存为草稿，请到用户空间-我的办件中查看')
                }
              })
            }
          })
        }
      }
    },
    submitDataHandle () {
      const that = this
      const jsonParams = sessionStorage.getItem(this.itemId + '_matter') ? JSON.parse(sessionStorage.getItem(this.itemId + '_matter')) : {} // 事项数据
      // 用户信息
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
          jsonParams.applyUserId = userParams.uid ? userParams.uid : undefined
          jsonParams.applyUserName = userParams.name ? userParams.name : undefined // 姓名是加密发回的带星号
        }
      }
      jsonParams.steps = this.stepNo // 进度条
      jsonParams.situationSelect = sessionStorage.getItem(this.itemId + '_listOfSituations') // 情形选择
      jsonParams.formData = sessionStorage.getItem(this.itemId + '_infoStr') // 信息填报
      // 信息填报回显用（提交草稿是要传）
      jsonParams.model = sessionStorage.getItem(this.itemId + '_model')
      jsonParams.reportingprogress = '100'
      const uploadInfo = sessionStorage.getItem(this.itemId + '_JiopwebMaterial') ? JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) : []
      uploadInfo.forEach(item => {
        if (item.data && item.data.length > 0) {
          item.data.forEach(ele => {
            ele.base64 = ''
            ele.thumbUrl = ''
          })
        }
      })
      jsonParams.uploadMaterial = JSON.stringify(uploadInfo) // 材料
      // 取件方式
      this.receiveParams = sessionStorage.getItem(this.itemId + '_JiopwebReceive')
      if (this.receiveParams) {
        if (parseInt(this.receiveParams.receiveType) === 1) {
          jsonParams.receiveType = 1
          jsonParams.receiveUserName = this.receiveParams.receiveUserName
          jsonParams.receivePhone = this.receiveParams.receivePhone
          jsonParams.receiveArea = this.receiveParams.receiveArea
          jsonParams.receiveDetailArea = this.receiveParams.receiveDetailArea
        } else {
          jsonParams.receiveType = 0
        }
      }
      const jsonstring = JSON.stringify(jsonParams)
      const encryptString = that.encrypt(jsonstring, this.publicKey)
      return encryptString
    },
    handleCancel () {
      // 弹窗提示用户是否保存草稿
      const that = this
      that.modalLoading = true
      that.$confirm({
        title: '确认要保存草稿吗?',
        okText: '保存',
        cancelText: '不保存',
        onOk () {
          // 保存草稿  传1 判断是从这里调用的
          that.saveDraft(1)
        },
        onCancel () {
          // 返回首页
          that.$router.push({ path: '/singleEventList', query: { bannerType: 'personal' } })
        }
      })
      that.modalLoading = false
    },
    handleEdit () {
      // 返回到申报信息页面进行修改
      this.modalLoading = true
      this.visible = false
      this.loading = false
      this.modalLoading = false
      console.log('返回修改')
    },
    getCheckInfo (type) {
      const that = this
      let userId = ''
      // 登录人员信息
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = JSON.parse(userInfo.desensitizeUser)
          userId = userParams.uid
        }
      }
      // 这边调完接口判断
      jiopWebAPI.findCheckInfo({ matterId: that.itemId, applyUserId: userId }).then(res => {
        if (res.success) {
          that.approveMsgInfo = res.data.approveMsgInfo
          if (that.approveMsgInfo) {
            that.approveResult = res.data.approveMsgInfo.approveResult
            clearInterval(that.timer)
            clearInterval(that.intervalId)
            // true 为通过
            if (that.approveResult) {
              if (type === 1) {
                // 补正
                that.cleanSession()
                const url = that.$router.resolve({ path: '/replenishMatterSuccess', query: { itemId: that.itemId, applyId: res.data.approveMsgInfo.applyNumber, stepNo: that.stepNo++, total: that.total } })
                window.open(url.href, '_blank')
              } else {
                // 提交
                that.cleanSession()
                const url = that.$router.resolve({ path: '/handlingMatterSuccess', query: { itemId: that.itemId, applyId: res.data.approveMsgInfo.applyNumber, stepNo: that.stepNo++, total: that.total } })
                console.log(res, 'submitHandle')
                sessionStorage.setItem('handlingSearchUrl', res.data.approveMsgInfo.handlingSearchUrl)
                sessionStorage.setItem('homePageSearchUrl', res.data.approveMsgInfo.homePageSearchUrl)
                window.open(url.href, '_blank')
              }
            } else {
              that.consistencyRule = res.data.approveMsgInfo.consistencyRule
              that.checkMaterialRule = res.data.approveMsgInfo.checkMaterialRule
              that.checkFieldRule = res.data.approveMsgInfo.checkFieldRule
              if ((that.consistencyRule && that.consistencyRule.length > 0) || (that.checkMaterialRule && that.checkMaterialRule.length > 0) || (that.checkFieldRule && that.checkFieldRule.length > 0)) {
                that.showOverlay = false
                that.visible = true
              }
            }
          }
        }
      })
    },
    startTimer (type) {
      // type 1 补正  2 正常办理
      const that = this
      that.timer = setInterval(() => {
        if (that.remainingTime > 0) {
          that.remainingTime--
          // 这里轮询异步调用方法 1s调一次
          that.getCheckInfo(type)
        } else {
          // 有值 说明跑完了 继续   true 通过 false 不通过  返approveMsgInfo
          if (that.approveMsgInfo) {
            if (that.approveResult) {
              if (type === 1) {
                // 补正
                that.cleanSession()
                const url = that.$router.resolve({ path: '/replenishMatterSuccess', query: { itemId: that.itemId, applyId: that.approveMsgInfo.applyNumber, stepNo: that.stepNo++, total: that.total } })
                window.open(url.href, '_blank')
              } else {
                // 提交
                that.cleanSession()
                const url = that.$router.resolve({ path: '/handlingMatterSuccess', query: { itemId: that.itemId, applyId: that.approveMsgInfo.applyNumber, stepNo: that.stepNo++, total: that.total } })
                console.log(that.approveMsgInfo, 'submitHandle')
                sessionStorage.setItem('handlingSearchUrl', that.approveMsgInfo.handlingSearchUrl)
                sessionStorage.setItem('homePageSearchUrl', that.approveMsgInfo.homePageSearchUrl)
                window.open(url.href, '_blank')
              }
            } else {
              clearInterval(that.timer)
              that.showOverlay = false
              that.visible = true
            }
          } else {
            clearInterval(that.timer)
            that.showOverlay = false
            that.$confirm({
              title: '是否直接提交？',
              content: '本次系统审批时间预计较长，是否直接提交办件？',
              okText: '直接提交',
              cancelText: '继续等待',
              onOk () {
                // 调用直接提交方法  二次提交
                that.loading = false
                that.handleSubmit(2, false)
              },
              onCancel () {
                // 弹窗消失，停留在等待系统审批状态页 继续轮询调用方法 30s后继续提示
                that.showOverlay = true
                that.intervalId = setInterval(() => {
                  that.getCheckInfo(type)
                }, 1000)
              }
            })
          }
        }
      }, 1000)
    },
    getinfoStr () {
      if (this.intelligentApproval === 'on') {
        // 开启智审 status 判断只是调用接口  不返回数据
        this.showOverlay = true
        this.remainingTime = 30
        this.handleSubmit(1, true)
        // 此时异步调用方法 return一个值 this.checkInfo 如果有值则弹窗 无值则弹出提示是否提交
        this.startTimer(2)
      } else {
        // type 1  一次提交  2   二次提交
        this.handleSubmit(1, false)
      }
      // 本地环境调试办件提交
      // this.submit(str, userId)
    },
    getCookieData (cookieName) {
      try {
        var cookieMsg = document.cookie.replace(/%/g, '%25')
        var decodedCookie = decodeURIComponent(cookieMsg)
        var cookieArray = decodedCookie.split(';')
        var name = cookieName + '='
        for (var i = 0; i < cookieArray.length; i++) {
          var cookie = cookieArray[i]

          while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1)
          }
          if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length)
          }
        }
        return ''
      } catch (err) {
        console.log(err, 'cookieErr')
      }
    },
    handleSubmit (type, status) {
      const situationSelect = sessionStorage.getItem(this.itemId + '_listOfSituations')
      let formData = []
      const matter = JSON.parse(sessionStorage.getItem(this.itemId + '_matter')) || {}
      // 材料
      // if (sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) {
      const uploadInfo = JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) || []
      uploadInfo.forEach(item => {
        if (item.data && item.data.length > 0) {
          item.data.forEach(ele => {
            ele.base64 = ''
            ele.thumbUrl = ''
          })
        }
      })
      console.log('保存提交的上传文件', uploadInfo)
      // 材料
      matter.uploadMaterial = JSON.stringify(uploadInfo)
      // }
      // 取件方式
      if (sessionStorage.getItem(this.itemId + '_JiopwebReceive')) {
        const receiveInfo = JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebReceive')) || undefined
        // 取件方式
        if (receiveInfo && parseInt(receiveInfo.receiveType) === 0) {
          matter.receiveType = 0
        } else {
          matter.receiveType = 1
          matter.receiveArea = receiveInfo.receiveArea
          matter.receiveUserName = receiveInfo.receiveUserName
          matter.receivePhone = receiveInfo.receivePhone
          matter.receiveDetailArea = receiveInfo.receiveDetailArea
        }
      }
      let str = ''
      matter.situationSelect = situationSelect
      matter.steps = this.$route.query.stepNo
      let uus = {}
      let userId = ''
      let userType = 1
      // 登录人员信息
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = JSON.parse(userInfo.desensitizeUser)
          matter.applyUserId = userParams.uid
          userId = userParams.uid
          userType = (this.getCookieData('userType') === 1 || parseInt(userParams.userType) === 1) ? 1 : 2
          // matter.applyUserName = userParams.name // 姓名是加密发回的带星号
          // 解密手机号
          let encodeUser = userInfo.encodeUser
          if (encodeUser) {
            const prikey = '5506c31374d5d8e9d79ba5ecc7cd1a7d60df3f7ef5fbb6865ccd9ce489751ac7'
            encodeUser = encodeUser.substring(2, encodeUser.length)
            const user2 = sm2.doDecrypt(encodeUser, prikey, 1)
            uus = JSON.parse(user2)
            matter.applyPhone = uus.mobile
            matter.applyUserName = uus.name
          }
        }
      }
      if (sessionStorage.getItem(this.itemId + '_infoStr') !== null) {
        formData = JSON.parse(JSON.parse(sessionStorage.getItem(this.itemId + '_infoStr'))).formData
        formData.forEach(item => {
          if (item.fieldName === 'applyPhone') {
            if (item.fieldValue !== '' && item.fieldValue !== undefined && item.fieldValue !== null) {
              // todo 判断值是否加密
              if (item.fieldName.indexOf('*')) {
                // 加密未修改
                matter.applyPhone = uus.mobile
                item.fieldValue = uus.mobile
              } else {
                matter.applyPhone = item.fieldValue
              }
            }
          }
          if (item.fieldName === 'applyname') {
            item.fieldValue = uus.name
          }
          if (item.fieldName === 'idnumber') {
            item.fieldValue = uus.certNo
          }
          // 法人
          if (item.fieldName === 'organizedata') {
            item.fieldValue = uus.creditCode
          }
          if (item.fieldName === 'legalpersonname') {
            item.fieldValue = uus.corUserName
          }
          if (item.fieldName === 'legalpersonid') {
            item.fieldValue = uus.corUserCertNo
          }
        })
      }
      const reportSystem = sessionStorage.getItem(this.itemId + '_reportSystem')
      matter.formData = formData
      matter.reportSystem = reportSystem === 'null' ? 'workflow' : reportSystem
      matter.handleType = this.$route.query.handleType
      matter.materialState = localStorage.getItem('materialState') === 'true' ? 'supplement' : 'nosupplement'
      matter.acceptFlowId = this.$route.query.acceptFlowId
      if (type === 1) {
        matter.intelligentApproval = this.$route.query.intelligentApproval
        matter.wholeIntelligentApproval = this.$route.query.wholeIntelligentApproval
      } else {
        matter.intelligentApproval = 'off'
        matter.wholeIntelligentApproval = 'off'
      }
      localStorage.setItem('materialState', false)
      console.log('保存提交', matter)
      str = JSON.stringify(matter)
      const that = this
      jiopWebAPI.getPublicKey({ userType: 1, appType: 1 }).then(res => {
        if (res.success) {
          str = that.encrypt(str, res.data.publicKey)
          if (status) {
            jiopWebAPI.submitHandle({ infoStr: str, applyUserId: userId, userType: userType, appType: 1 })
            that.loading = false
          } else {
            jiopWebAPI.submitHandle({ infoStr: str, applyUserId: userId, userType: userType, appType: 1 }).then(res => {
              if (res.success) {
                that.loading = false
                that.cleanSession()
                const url = that.$router.resolve({ path: '/handlingMatterSuccess', query: { itemId: that.itemId, applyId: res.data.transactNo, stepNo: that.stepNo++, total: that.total } })
                console.log(res, 'submitHandle')
                sessionStorage.setItem('handlingSearchUrl', res.data.handlingSearchUrl)
                sessionStorage.setItem('homePageSearchUrl', res.data.homePageSearchUrl)
                window.open(url.href, '_blank')
              } else {
                that.loading = false
              }
            })
          }
        }
      })
    },
    encrypt: function (str, publicKey) {
      return '04' + sm2.doEncrypt(str, publicKey, 1)
    },
    submit (str, userId) {
      str = this.encrypt(str, '042b84ff64c2f5dc9a498a0f7dfe20922ccc45782661ac6bdd58663c0b6e9341fbbf4a2323e0721c48cd0868236a341beb604373bffce98f296edf470f5e385cf8')
      jiopWebAPI.submitHandle({ infoStr: str, applyUserId: userId }).then(res => {
        if (res.success) {
          this.loading = false
          this.cleanSession()
          const url = this.$router.resolve({ path: '/handlingMatterSuccess', query: { itemId: this.itemId, applyId: res.data.transactNo, stepNo: this.stepNo++, total: this.total } })
          window.open(url.href, '_blank')
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.custom-modal-word {
  font-family: 'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 28px;
  color: #FFFFFF;
  text-align: center;
  line-height: 25px;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 背景透明 */
  z-index: 9999; /* 保证在最顶层 */
}

.custom-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
}

.custom-modal-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
  width: 224px;
  height: 202px;
  pointer-events: none; /* 图片不能被点击 */
}
.modal {
  &-footer {
    margin: 16px 10px 16px 14px;
    &-title {
      font-family: 'PingFangSC-Regular', sans-serif;
      font-size: 14px;
      color: #999999;
      font-weight: 400;
      float: left;
      margin-top: 9px;
    }
    &-button {
      ::v-deep .ant-btn {
        border-radius: 2px;
        height: 40px;
      }
    }
  }
  &-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
    width: 224px;
    height: 202px;
  }
}

::v-deep .ant-modal-body {
  padding: 20px !important;
}
.list {
  &-image {
    margin-right: 8px;
    width: 6px;
  }
  &-title {
    font-family: 'PingFangSC-Medium', sans-serif;
    font-size: 16px;
    color: #333333;
    line-height: 26px;
    font-weight: 500;
    margin-bottom: 4px;
  }
  &-sub {
    &-title {
      font-family: 'PingFangSC-Regular', sans-serif;
      font-size: 14px;
      color: #333333;
      line-height: 35px;
      font-weight: 400;
      margin-left: 15px;
    }
    &-tagOk {
      float: right;
      margin: 5px 48px 0 0;
      background: #F1FFEB;
      border: 1px solid #76E049;
      border-radius: 4px;
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 12px;
      color: #6DD400;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: 400;
      text-align: center;
    }
    &-tagOff {
      float: right;
      margin: 5px 48px 0 0;
      background: #FFEBEB;
      border: 1px solid #FF9999;
      border-radius: 4px;
      width: 64px;
      height: 22px;
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 12px;
      color: #E02020;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: 400;
      text-align: center;
    }
    &-message {
      font-family: 'PingFangSC-Regular', sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #E02020;
      margin-left: 30px;
    }
  }
}
</style>
